import { Navbar } from "react-bootstrap";
import "../styles/styles.scss";

export default function NavBar() {
  return (
    <>
      <Navbar
        bg="light"
        variant="dark"
        className="justify-content-between navbar-height fixed-top"
      >
        <Navbar.Brand href="/">
          <div className="navbar-logo"></div>
        </Navbar.Brand>
        <h5 className="navbar-text">
          TRÁMITE SIMPLIFICADO DE UNIDADES DE TRANSPORTE
        </h5>
      </Navbar>
    </>
  );
}
